import help_general from '@/helpers/general';

export default {
	getFieldValidation: help_general.getFieldValidation,
	validate(){
		const self = this;
		return new Promise((resolve, reject) => {
			self.$validator.validateAll()
			.then((result) => {
		        if (result) {
		          resolve(result);
		          return;
		        }

	        	reject(result);
	      	});
		});
	}
};



// WEBPACK FOOTER //
// ./src/helpers/fieldvalidation.js